module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-aaa1d6ef.png";